import { formatTimestamp } from '../lib/format';
import { useQuota } from './quota/useQuota';

/**
 * Remaining monthly generations. Permanently visible per SRS §2 — a flat
 * number, no credit weights.
 *
 * An unknown allowance (still loading, or the lookup failed) reads `--/--`
 * rather than zero: the counter reports, it does not gate. The only thing that
 * stops a run is the backend's 429, which the generation form turns into a
 * message.
 */
export function QuotaCounter() {
  const { quota } = useQuota();

  const isEmpty = quota !== null && quota.remaining === 0;
  const label = quota
    ? `${quota.remaining} of ${quota.limit} posts left this month. Resets ${formatTimestamp(quota.resets_at)}.`
    : 'Posts remaining this month';

  return (
    <div className={isEmpty ? 'quota quota--empty' : 'quota'} aria-label={label} title={label}>
      <span className="quota__label">Posts left</span>
      <span className="quota__value">
        {quota?.remaining ?? '--'}
        <span className="quota__limit">/{quota?.limit ?? '--'}</span>
      </span>
    </div>
  );
}
